import React, { useContext, useState } from 'react';
import { ImageCarousel } from '@dmm/lib-react-ui-components';
import get from 'lodash/get';
import { BDPContext } from '../MainContent/BoatDetailsPage';
import { useBdpActions } from '../MainContent/bdpController/bdpActions';
import SocialShare from '../../../components/SocialShare';
import { setSoftLeadEvent } from '../../../store/actions/dataLayer';
import { useDispatch } from 'react-redux';
import CarouselModal from '../../../components/CarouselModal';
import StackedGalleryModal from '../../../components/StackedGalleryModal';
import PropTypes from 'prop-types';
import { getPartyBrandedSRP } from '../../../utils/urlHelpers/party';
import { addLead } from '../../../store/actions/dataLayer';
import { get360Photos, populateMediaArray } from '../../../utils/listingHelper';
import { syncTranslationElements } from '../../../utils/translations/translationsSync';
import {useIntl} from 'react-intl';
import { useFeatureFlags } from '../../../context/hooks/useFeatureFlags';
import { isBoatDetailsPageRedesign } from '../../../utils/newBDPHelper';
import { PortalConfigContext } from '../../../config/portal';

const BDPCarouselModal = (props) => {
  const intl = useIntl();
  const { messages, t } = syncTranslationElements(intl);
  const { featureFlagBDPNewDesign } = useFeatureFlags();
  const { listing, carouselItems, cookies, url, myboats, carouselThumbnails } = useContext(BDPContext);
  const hasImmersiveTour = !!get(listing, 'virtualTour', false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const { changeCarouselImage, carouselButtonClick } = useBdpActions();
  const dispatch = useDispatch();
  const {
    breakpoint,
    isWorking,
    show,
    carouselIndex,
    hideModal,
    carouselAddParams,
    carouselButtons,
    handleOpenContactForm,
    openImmersiveTourModal,
    handleCarouselItemClick,
    adReload,
    pageAdsConfig,
    targeting,
    bdpUrl
  } = props;
  const { mediaItems } = carouselItems;
  const onClickPreviousNext = () => {
    changeCarouselImage();
    carouselButtonClick();
  };
  const handleClickShare = () => {
    setOpenShareModal(!openShareModal);
  };

  const openImmersiveTourModalHandler = () => {
    dispatch(setSoftLeadEvent('immersive tour'));
    openImmersiveTourModal();
  };

  let modalMediaItems = populateMediaArray(listing);

  const images360 = get360Photos(listing);
  const index360 = modalMediaItems.findIndex(
    (media) => media.mediaType === '360Image'
  );

  const imageCarouselOptions = [
    {
      label: t(messages.viewCarousel360Images.image360),
      onClick: (e) => handleCarouselItemClick(e, index360),
      show: images360.length > 0
    },
    {
      label: t(messages.immersiveTour),
      onClick: openImmersiveTourModalHandler,
      show: hasImmersiveTour
    },
    {
      label: t(messages.dealerBoats),
      url: getPartyBrandedSRP(listing.owner, false, listing.make),
      rest: { 'data-reporting-click-internal-link-id': 'more-from-broker' },
      show: Boolean(listing.owner && listing.owner.id),
      onClick: () => {
        dispatch(addLead(listing.id, 'view all inventory'));
      }
    }
  ];

  const showThumbnails = breakpoint === 'desktop' && featureFlagBDPNewDesign && carouselThumbnails.length > 0;
  const context = useContext(PortalConfigContext);
  const showStackedGallery = breakpoint !== 'desktop' && featureFlagBDPNewDesign && isBoatDetailsPageRedesign(context);
  const showCounter = breakpoint !== 'desktop';
  const noImageMessage = t(messages.defaultNotFoundImage);
  const emptyCarousel = { message: noImageMessage, altMessage: noImageMessage };

  carouselThumbnails[0].onClick = (e) => {
    handleCarouselItemClick(e, 0);
  };

  return (
    <>
    {!showStackedGallery && (
      <CarouselModal
        device={breakpoint}
        isLoading={isWorking}
        listing={listing}
        cookies={cookies}
        url={url}
        myboats={myboats}
        show={show}
        showThumbs={true}
        selectedCarouselItem={carouselIndex}
        hideModal={hideModal}
        adParams={carouselAddParams}
        adReload={adReload}
        breakpoint={breakpoint}
        handleOpenContactForm={handleOpenContactForm}
        openImmersiveTourModal={openImmersiveTourModal}
        onCarouselContactButton={handleOpenContactForm}
      />
    )}
    {showStackedGallery && (
      <StackedGalleryModal
        listing={listing}
        show={show}
        hideModal={hideModal}
        onClickShare={handleClickShare}
        adParams={carouselAddParams}
        isLoading={isWorking}
        pageAdsConfig={pageAdsConfig}
        targeting={targeting}
        bdpUrl={bdpUrl}
      />
    )}
      <ImageCarousel
        previousOnClick={() => onClickPreviousNext()}
        nextOnClick={() => onClickPreviousNext()}
        items={mediaItems}
        buttons={carouselButtons}
        onClickImmersive={openImmersiveTourModalHandler}
        showImmersiveTour={hasImmersiveTour}
        hideLikeButton={true}
        showButtons={breakpoint === 'desktop'}
        handleCarouselItemClick={handleCarouselItemClick}
        onClickShare={handleClickShare}
        options={imageCarouselOptions}
        showCounter={showCounter}
        emptyCarousel={emptyCarousel}
        classNames={{ thumbnails: showThumbnails }}
        thumbnails={carouselThumbnails}
      />
      <SocialShare
        type="overlay"
        listing={listing}
        handleOpenContactForm={handleOpenContactForm}
        breakpoint={breakpoint}
        openShareModal={openShareModal}
        handleShareButton={handleClickShare}
        handleShareToggle={() => {}}
        openImmersiveTourModal={() => {
          openImmersiveTourModal();
          setOpenShareModal(false);
        }}
      />
    </>
  );
};

BDPCarouselModal.propTypes = {
  breakpoint: PropTypes.string,
  isWorking: PropTypes.bool,
  show: PropTypes.bool,
  carouselIndex: PropTypes.number,
  hideModal: PropTypes.func,
  carouselAddParams: PropTypes.object,
  carouselButtons: PropTypes.array,
  handleOpenContactForm: PropTypes.func,
  openImmersiveTourModal: PropTypes.func,
  handleCarouselItemClick: PropTypes.func,
  adReload: PropTypes.number,
  pageAdsConfig: PropTypes.object,
  targeting: PropTypes.object,
  bdpUrl: PropTypes.string
};

export default BDPCarouselModal;
